<template>
<div class="mr-2">
  <b-nav-item-dropdown right no-caret @shown="markNotificationsAsRead()">
    <template slot="button-content">
      <a class="nav-link mr20">
        <icon icon="bell"></icon>
        <span class="krug-notification" v-if="data.totalCount > 0">{{data.totalCount}}</span>
      </a>
    </template>
    <b-dropdown-item v-for="item in data.root" :key="item.notificationIs" v-on:click="markAsRead(item)"><a>{{item.username}}: {{item.date}}</a></b-dropdown-item>
  </b-nav-item-dropdown>
  <b-modal ref="formmodal" :title="$t('NOTIFICATION')" no-close-on-backdrop>
    <p class="my-4">{{answer}}</p>
  </b-modal>
</div>
</template>
<script>
import
{
  mapGetters,
  mapActions
}
from 'vuex'
import Api from '@/api/admin/Notifications'

export default
{
  name: 'header-dropdown-accnt',
  created: function()
  {
    var me = this;
    me.getData();

    me.$subscribe(`notification`, (data) =>
    {
        me.getData();
    });
    // me.startInterval();
  },
  data: function()
  {
    return {
      data:
      {},
      answer: '',
    }
  },
  methods:
  {
    async markNotificationsAsRead()
    {
      const me = this;
      await Api.markNotificationsAsRead({});
      await me.getData();
    },
    async getData()
    {
      var me = this;
      try
      {
        var data = await Api.selectRow();
        if (data.error && data.error == true)
        {
          //me.$notify.notice(data);
          me.loading = false;
          return;
        }

        me.data = data;
      }
      catch (e)
      {
        me.$notify.notice(e);
      }
    },
    /*
    *
    * 1 = blog
    * 2 = ticket answer
    * 3 = questionproggress
    * * = ticket modal
    * 
    * */
    async markAsRead(item)
    {
      var me = this;
      try
      {
        var data = await Api.markAsRead(item);

        console.log('wtff');
        if (data.error)
        {
          me.$notify.notice(data);
        }
        else
        {
          me.$notify.notice(data);
          await me.getData();

          if (item.win === 'warranty')
          {
            me.$router.push(
            {
              path: `/warranty`,
              query: { openForm: true, warrantyId: item.sourceId }
            });
          }
          else if (item.win === 'storetostore')
          {
            me.$router.push(
            {
              path: `/storetostoretransfer`,
              query: { openForm: true, storeToStoreId: item.sourceId }
            });
          }
          else if (item.isBlog == 1)
          {
            me.$router.push(
            {
              path: `/dashboard/dashboarddetails/${item.sourceId}`
            });
          }
          else if (item.isBlog == 2)
          {
            me.answer = item.answer;
            this.$refs.formmodal.show();
          }
          else if (item.isBlog == 3)
          {
            me.$router.push(
            {
              path: `/system/users/questionprogres/${item.userId}`,
              query: { isNotification: true, questionFormId: item.sourceId }
            });
          }
          else if (item.isBlog == me.globals.salesStaf)
          {
            me.$router.push(
            {
              path: `/warranty`,
              query: { openForm: true, warrantyId: item.sourceId }
            });
          }
          else if (item.isBlog == me.globals.servicer)
          {
            me.$router.push(
            {
              path: `/warranty`,
              query: { openForm: true, warrantyId: item.sourceId }
            });
          }
          else
          {
            me.$router.push(
            {
              path: `/system/ticket`
            });
          }
        }
      }
      catch (e)
      {
        console.log(e);
        me.$notify.notice(e);
      }
    },
    startInterval()
    {
      var me = this;
      setInterval(function()
      {
        me.getData();
      }, 60000)
    }
  },
  computed:
  {
    ...mapGetters([
      'globals'
    ]),
  }
}
</script>
